enum FundingAccountVerifyMicroDepositFieldNames {
    firstMicroDeposit = "funding_account_micro_deposit_first_deposit",
    secondMicroDeposit = "funding_account_micro_deposit_second_deposit"
}

export default FundingAccountVerifyMicroDepositFieldNames;